import { IconCheck, IconPlayerPlayFilled } from "@tabler/icons-react";
import { cn } from "@/lib/utils";

// Sizes are in cqw so the overlay scales with the thumbnail width.
export default function VideoThumbnail({
  title,
  imageSrc,
  minutes,
  isOpened,
  className,
}: {
  title: string;
  imageSrc: string;
  minutes?: number;
  isOpened?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "@container relative aspect-video overflow-hidden rounded-xl bg-grey-200 text-left",
        className,
      )}
    >
      <img
        src={imageSrc}
        alt=""
        className="absolute inset-0 size-full object-cover transition-transform duration-300 group-hover:scale-103"
      />
      <div className="absolute inset-0 bg-linear-to-r from-black/50 via-black/15 to-transparent" />
      <div className="absolute inset-0 bg-linear-to-t from-black/40 via-transparent to-transparent" />
      {isOpened && (
        <span className="absolute right-[7cqw] bottom-[6cqw] flex items-center gap-[1cqw] py-[1.8cqw] text-[length:3.2cqw] font-medium text-white/90 text-shadow-sm">
          <IconCheck className="size-[3.5cqw]" stroke={2.5} />
          Watched
        </span>
      )}
      <p className="absolute top-[7cqw] left-[7cqw] max-w-[55%] text-[length:7cqw] leading-[1.1] font-bold text-white text-shadow-md">
        {title}
      </p>
      <span className="absolute bottom-[6cqw] left-[7cqw] flex items-center gap-[1.5cqw] rounded-full border border-white/30 bg-white/20 px-[3.5cqw] py-[1.8cqw] text-[length:3.2cqw] font-medium text-white backdrop-blur-md transition-colors group-hover:bg-white/30">
        <IconPlayerPlayFilled className="size-[3cqw]" />
        {minutes ? `Watch · ${minutes} min` : "Watch"}
      </span>
    </div>
  );
}
